import Logo from './Logo';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-dark py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-8">
        <div className="flex items-center align-middle gap-2.5">
          <Logo size={30} invert />
          <div className="flex flex-col leading-tight space-y-1 -mb-2">
            <span className="text-white font-semibold text-sm tracking-tight -mb-1.5">Vehi Systems</span>
            <span className="text-white/70 text-xs tracking-wide">Built Around You</span>
          </div>
        </div>

        <div className="flex flex-col sm:items-end gap-2">
          <a
            href="mailto:hello@vehi.systems"
            className="text-white/75 text-sm hover:text-white transition-colors duration-150"
          >
            hello@vehi.systems
          </a>
          <p className="text-white/70 text-xs">&copy; {year} Vehi Systems</p>
        </div>
      </div>
    </footer>
  );
}
